export const sortAlphabetic = <T>(arr: T[], key: keyof T): T[] =>
  [...arr].sort((a, b) =>
    String(a[key]).localeCompare(String(b[key]), undefined, {
      sensitivity: "base",
    }),
  );
